import { render, staticRenderFns } from "./PermissionAlertGate.vue?vue&type=template&id=308900dc"
import script from "./PermissionAlertGate.vue?vue&type=script&lang=js"
export * from "./PermissionAlertGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports